import React, { useState, useRef } from "react";
import { useDispatch, useStore, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import {
  Card,
  Button,
  Col,
  message,
  Modal,
  Input,
  Avatar,
  Menu,
  Dropdown,
  Radio,
  Breadcrumb,
  Form,
  Row,
  Table,
  Select,
  Checkbox,
  Divider,
} from "antd";
import {
  PlusCircleOutlined,
  PrinterFilled,
  TagFilled,
} from "@ant-design/icons";
import {
  isEmptyObject,
  removeSpacewithLowerCaseString,
  getDecryptID,
  StringIsNullOrEmpty,
} from "../../appRedux/actions/GlobalMethods";
import { PrintBarcodes } from "./PrintBarcodes";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { parse } from "path";
import BarCodePreview from "./BarCodePreview";
import { SKULabelPrintFormat } from "../../constants/SKULabelPrintFormat";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};
const ModalTTypeOptions = [
  {
    OptionID: 1,
    value: "Quantity",
    OptionName: "components.barcodegenerator.quantity",
  },
  {
    OptionID: 2,
    value: "CustomizeLabel",
    OptionName: "components.barcodegenerator.Customizelabel",
  },
];
const ModalTypeButtons = [
  {
    OptionID: 1,
    formName: "Quantity",
    ButtonName1: "components.barcodegenerator.close",
    ButtonName2: "sell.sell.moreactions.next",
    IsDisabledB2: false, //its button 2
  },
  {
    OptionID: 2,
    formName: "CustomizeLabel",
    ButtonName1: "components.barcodegenerator.back",
    ButtonName2: "components.barcodegenerator.print",
    IsDisabledB2: false, //its button 2
  },
];
const ModalTypeContent = [
  {
    OptionID: 1,
    formName: "Quantity",
    Heading: "components.barcodegenerator.chooselabelquantity",
    Description: "",
  },
  {
    OptionID: 2,
    formName: "CustomizeLabel",
    Heading: "components.barcodegenerator.howdoyou",
    Description: "",
  },
];

const BarCodeGenerator = (props) => {
  const buttonType = props.buttonType != undefined ? props.buttonType : "";
  const barcodeProducts =
    props.barcodeData != undefined ? props.barcodeData : "";
  const currencyCode =
    props.currencySymbol != undefined ? props.currencySymbol : "";

  const componentRef = useRef();
  const getReduxDefaultLabelPrintFormat = useSelector(
    ({ Setup }) => Setup.defaultLabelPrintFormat
  );

  let productData = [];
  let batchesData = [];
  if (barcodeProducts != undefined && barcodeProducts != null) {
    const productName = barcodeProducts.productName;
    if (
      removeSpacewithLowerCaseString(barcodeProducts.productInventoryType) ===
      removeSpacewithLowerCaseString("Product with Variants")
    ) {
      barcodeProducts &&
        barcodeProducts.productVariant &&
        barcodeProducts.productVariant.map((x, index) => {
          let productSKUObj1 = {
            Key: index,
            productName: productName,
            quantity: 1,
            imageURL: x.imageURL,
            variantName: x.variantName,
            isVariant: true,
            SKUCode: x.productSKU ? x.productSKU[0].SKUValue : "",
            retailPrice: x.retailPrice,
          };
          productData.push(productSKUObj1);
        });
    } else {
      let productSKUObj2 = {
        Key: 0,
        productName: productName,
        productID: barcodeProducts.productID,
        quantity: 1,
        imageURL: barcodeProducts.imageURL,
        variantName: "",
        isVariant: false,
        SKUCode: barcodeProducts.productSKU
          ? barcodeProducts.productSKU[0].skuValue
          : "",
        retailPrice: barcodeProducts.retailPrice,
        productBatchesData: barcodeProducts.productBatchesData,
        batchNo: "",
      };

      batchesData = barcodeProducts.productBatchesData;
      productData.push(productSKUObj2);
    }
  }

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const handleFocus = (event) => event.target.select();
  const [getBarCodeModalVisible, setBarCodeModalVisible] =
    React.useState(false);
  const [getCurrentModalType, setCurrentModalType] = React.useState(1);
  const [getModalTypeOptions, setModalTypeOptions] = React.useState([]);
  const [getModelTypeButtons, setModelTypeButtons] = React.useState([]);
  const [getModelTypeContent, setModelTypeContent] = React.useState([]);
  const [getSKUProducts, setSKUProducts] = React.useState(productData);
  const [getCheckedLabelContent, setCheckedLabelContent] = React.useState([
    "1",
    "2",
    "3",
    "4",
  ]);
  const [getContentLabelType, setContentLabelType] = React.useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState(
    productData.length > 0 ? productData.map((item) => item.Key) : []
  );
  const [getBatchesData, setBatchesData] = React.useState(batchesData);
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      setModalTypeOptions(ModalTTypeOptions);
      setModelTypeButtons(ModalTypeButtons);
      setModelTypeContent(ModalTypeContent);
    }
    return () => (mounted = false);
  }, []);

  const handleBarCodeModalVisibility = (isVisible) => {
    setCurrentModalType(1);
    setBarCodeModalVisible(isVisible);
  };
  const handleClickModalType = (modalType) => {
    if (modalType == 2) {
      setCurrentModalType(modalType);
    } else if (modalType == 3) {
      //Here we print the SKU
      message.success("Print SKU");
      handlePrint();
    }
  };
  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }
  const QuantityContent = (props) => {
    const columns = [
      {
        title: <IntlMessages id="components.barcodegenerator.sku" />,
        dataIndex: "productName",
        render: (text, record) => {
          const url = `/dashboard/products/main/productdetail/${record.productID}`;
          return (
            <>
              <div
                // onClick={() => history.push(url)}
                style={{ cursor: "pointer" }}
                className="gx-module-list-icon"
              >
                <div className="gx-d-none gx-d-sm-flex">
                  <Avatar
                    shape="square"
                    size={35}
                    alt={"salis"}
                    src={record.ImageURL}
                  />
                </div>
                <div className="gx-ml-2  gx-d-sm-flex">
                  <span>
                    {record.isVariant ? record.variantName : record.productName}
                  </span>
                  {/* <a
                    href={"/Dashboard/products/supplier/view/" + record.key}
                    className="gx-link"
                  >
                    {record.productName}
                  </a> */}
                </div>
              </div>
            </>
          );
        },
      },
      {
        title: <IntlMessages id="components.barcodegenerator.quantity" />,
        dataIndex: "quantity",
        editable: true,
        render: (text, record, index) => {
          function putQuantity() {
            let quantityName = `quantity${record.key}`;
            form.setFieldsValue({
              [quantityName]: record.quantity ? parseFloat(record.quantity) : 0,
            });
          }
          putQuantity();
          return (
            <Form form={form} name="BarcodeProductForm" scrollToFirstError>
              <Form.Item style={{ margin: 0 }} name={`quantity${record.key}`}>
                <Input
                  value={text}
                  onPressEnter={(v) => onQuantityChange(v, index, record)}
                  onChange={(v) => onQuantityChange(v, index, record)}
                  // onFocus={(e) => handleFocus(e)}
                />
              </Form.Item>
            </Form>
          );
        },
        shouldCellUpdate: (record, prevRecord) => {
          return record.quantity !== prevRecord.quantity;
        },
      },
    ];

    const onQuantityChange = ({ target: { value } }, index, record) => {
      let prevData = [...getSKUProducts];
      let newData = prevData[index];
      let newQuantity = parseFloat(value);
      newData.quantity = newQuantity;
      prevData[index] = newData;
      setSKUProducts(prevData);
      if (newQuantity <= 0) {
        setSelectedRowKeys(arrayRemove(selectedRowKeys, record.Key));
      } else {
        let rowKeys = selectedRowKeys;
        rowKeys.push(record.Key);
        setSelectedRowKeys(rowKeys);
      }
    };
    const onSelectChange = (newSelectedRowKeys) => {
      let skuProduct = [...getSKUProducts];

      for (let i = 0; i < skuProduct.length; i++) {
        if (
          newSelectedRowKeys.filter((x) => x == skuProduct[i].Key).length > 0
        ) {
          let newKeyData = skuProduct[i];
          newKeyData.quantity = 1;
          skuProduct[i] = newKeyData;
        } else {
          let newKeyData1 = skuProduct[i];
          newKeyData1.quantity = 0;
          skuProduct[i] = newKeyData1;
        }
      }

      setSKUProducts(skuProduct);
      setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
      selectedRowKeys,
      onChange: onSelectChange,
    };
    return (
      <>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={getSKUProducts}
          rowClassName={() => "editable-row"}
          pagination={false}
          footer={false}
          rowKey={(record) => record.Key}
        ></Table>
      </>
    );
  };
  function GetLabelClassandWidth(labelContentType) {
    let labelClass = "dk-sku-print-child-1-1";
    let barcodeWidth = 2;
    let barcodeHeight = 35;
    switch (labelContentType) {
      case 1:
        labelClass = "dk-sku-print-child-1-1";
        barcodeWidth = 2; //4
        barcodeHeight = 25;
        break;
      case 2:
        labelClass = "dk-sku-print-child-1-1";
        barcodeWidth = 2;
        barcodeHeight = 25;
        break;
      case 3:
        labelClass = "dk-sku-print-child-2-1";
        barcodeWidth = 2;
        barcodeHeight = 30;
        break;
      case 4:
        labelClass = "dk-sku-print-child-3-1";
        barcodeWidth = 2;
        barcodeHeight = 25;
        break;
      case 5:
        labelClass = "dk-sku-print-child-5-1";
        barcodeWidth = 2;
        barcodeHeight = 35;
        break;
      case 6:
        labelClass = "dk-sku-print-child-3-1";
        barcodeWidth = 2;
        barcodeHeight = 25;
        break;
      case 7:
        labelClass = "dk-sku-print-child-4-1";
        barcodeWidth = 2;
        barcodeHeight = 35;
        break;
      case 8:
        labelClass = "dk-sku-print-child-4-1";
        barcodeWidth = 1;
        barcodeHeight = 25;
        break;
      default:
        labelClass = "dk-sku-print-child-1-1";
        barcodeWidth = 2;
        barcodeHeight = 35;
        break;
    }
    let obj = {
      labelClass: labelClass,
      barcodeWidth: barcodeWidth,
      barcodeHeight: barcodeHeight,
    };
    return obj;
  }
  const CustomizeLabelContent = () => {
    const onFinish = (value) => {};

    const options = [
      {
        label: "Barcode",
        value: "1",
      },
      {
        label: "Primary SKU Code",
        value: "2",
      },
      {
        label: "Name",
        value: "3",
      },
      {
        label: "Default Retail Price",
        value: "4",
      },
      {
        label: "Batch No",
        value: "5",
      },
    ];
    const onChange = (checkedValues) => {
      setCheckedLabelContent(checkedValues);
      
      //console.log("checked = ", checkedValues);
    };
    const previewProductData = {
      ProductName:
        getSKUProducts && getSKUProducts[0].isVariant
          ? getSKUProducts[0].variantName
          : getSKUProducts[0].productName,
      RetailPrice: `${currencyCode} ${
        getSKUProducts && getSKUProducts[0].retailPrice
      }`,
      SKUCode: getSKUProducts && getSKUProducts[0].SKUCode,
      batchNo: getSKUProducts && getSKUProducts[0].batchNo,
    };
    const onChangeLabelType = (e) => {
      setContentLabelType(e);
    };

    return (
      <>
        <Row>
          <Col md={12}>
            <Form
              {...formItemLayout}
              form={form}
              name={"BarcodeGenerateForm"}
              layout="horizontal"
              onFinish={onFinish}
              initialValues={{
                LabelType: parseInt(getReduxDefaultLabelPrintFormat),
              }}
            >
              <Form.Item
                className="ant-form-item-label-custom"
                name="LabelType"
                label={
                  <IntlMessages id="components.barcodegenerator.labeltype" />
                }
              >
                <Select
                  onChange={(e) => {
                    onChangeLabelType(e);
                  }}
                >
                  {SKULabelPrintFormat &&
                    SKULabelPrintFormat.filter((x) => x.IsActive == true).map(
                      (e, key) => {
                        return <option value={e.id}>{e.labelName}</option>;
                      }
                    )}
                </Select>
              </Form.Item>
              <p className="custom-font-weight-500 dk-font-size-preview dk-mg-bt-5">
                <IntlMessages id="components.barcodegenerator.selectlabelcontent" />
              </p>
              <Checkbox.Group
                style={{ display: "flex", flexDirection: "column" }}
                options={options}
                value={getCheckedLabelContent}
                // defaultValue={getCheckedLabelContent}
                onChange={onChange}
              />
            </Form>
          </Col>
          <Col md={12}>
            <p className="custom-font-weight-500 dk-font-size-preview dk-mg-bt-5">
              <IntlMessages id="components.barcodegenerator.preview" />
            </p>
            <Card className="dk-labels-preview-container ">
              <BarCodePreview
                labelContentVisible={getCheckedLabelContent}
                productObj={previewProductData}
                designObj={GetLabelClassandWidth(getContentLabelType)}
              />
              <Divider style={{ borderColor: "#bfbebe" }} />
              <p
                className="dk-text-supplementary"
                style={{ marginTop: "15px" }}
              >
                <IntlMessages id="components.barcodegenerator.labelshelpstaff" />
              </p>
            </Card>
          </Col>
        </Row>
      </>
    );
  };
  const BarCodeModal = (props) => {
    return (
      <Modal
        transitionName=""
        maskTransitionName=""
        title={
          <div>
            <Breadcrumb separator=">">
              {getModalTypeOptions &&
                getModalTypeOptions.map((e, key) => {
                  return (
                    <Breadcrumb.Item
                      key={key}
                      className={
                        e.OptionID == getCurrentModalType
                          ? "custom-breadcrumb-color custom-active-breadcrumb"
                          : "custom-breadcrumb-color"
                      }
                    >
                      <IntlMessages id={`${e.OptionName}`} key={e.OptionID} />
                    </Breadcrumb.Item>
                  );
                })}
            </Breadcrumb>
          </div>
        }
        className="fullfillment-modal"
        visible={props.isVisible}
        okText={<IntlMessages id="common.resource.save" />}
        onCancel={() => {
          handleBarCodeModalVisibility(false);
        }}
        // bodyStyle={{ height: 300, overflowX: "scroll" }}
        width={700}
        centered={true}
        footer={
          getModelTypeButtons &&
          getModelTypeButtons
            .filter((x) => x.OptionID == getCurrentModalType)
            .map((e, index) => {
              return (
                <div key={index}>
                  <Button
                    type="primary"
                    className="dk-btn-expand-cancel"
                    onClick={() => {
                      if (e.OptionID == 1) {
                        handleBarCodeModalVisibility(false);
                      } else {
                        handleClickModalType(e.OptionID - 1);
                        setCurrentModalType(getCurrentModalType - 1);
                      }
                    }}
                  >
                    <IntlMessages id={e.ButtonName1} />
                  </Button>

                  <Button
                    type="primary"
                    className="dk-btn-add"
                    // disabled={e.OptionID == 2 && isEmptyObject(getCustomerObj)}
                    onClick={() => handleClickModalType(e.OptionID + 1)}
                  >
                    <IntlMessages id={e.ButtonName2} />
                  </Button>
                </div>
              );
            })
        }
      >
        <Row className="custom-mg-bt">
          <Col md={24}>
            {getModelTypeContent &&
              getModelTypeContent
                .filter((x) => x.OptionID == getCurrentModalType)
                .map((e, key) => {
                  return (
                    <div key={key}>
                      <h1 className="dk-quick-modal-header">
                        <IntlMessages id={e.Heading} />
                      </h1>
                      <p className="">
                        {!StringIsNullOrEmpty(e.Description) ? (
                          <IntlMessages id={e.Description} />
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  );
                })}
          </Col>
        </Row>
        {getCurrentModalType == 1 ? (
          <QuantityContent />
        ) : getCurrentModalType == 2 ? (
          <CustomizeLabelContent />
        ) : (
          ""
        )}

        {getCheckedLabelContent.filter((x) => x == "5").length > 0 &&
        getCurrentModalType == 2 ? (
          <>
            <Row>
              <Col md={12}>
                <Form
                  {...formItemLayout}
                  form={form}
                  name={"BarcodeGenerateForm"}
                  layout="horizontal"
                  // initialValues={{ BatchNo : parseInt( getReduxDefaultLabelPrintFormat) }}
                >
                  <Form.Item
                    className="ant-form-item-label-custom"
                    name="BatchNo"
                    // label={
                    //   <IntlMessages id="components.barcodegenerator.batchno" />
                    // }
                  >
                    <Select
                      onChange={(e) => {
                        
                        let getProducts = [...getSKUProducts];

                        getProducts[0].batchNo = e;
                       
                        setSKUProducts(getProducts);
                      }}
                    >
                      {getBatchesData &&
                        getBatchesData.map((e, key) => {
                          return (
                            <option value={getDecryptID(e.batchID)+"-"+e.batchCode}>
                              {getDecryptID(e.batchID)+"-"+e.batchCode}
                            </option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col md={12}></Col>
            </Row>
          </>
        ) : (
          ""
        )}
        {/* <div className="dk-sku-print-parent">
          {getSKUProducts &&
            getSKUProducts.map((x) => {
              let previewProductData = {
                ProductName: x && x.isVariant ? x.variantName : x.productName,
                RetailPrice: `${currencyCode} ${x && x.retailPrice}`,
                SKUCode: x && x.SKUCode,
              };
              return (
                <div className="dk-sku-print-child">
                  <BarCodePreview
                    labelContentVisible={getCheckedLabelContent}
                    productObj={previewProductData}
                  />
                </div>
              );
            })}
        </div> */}
      </Modal>
    );
  };
  const ButtonLayouts = (props) => {
    switch (props.type) {
      case "ProductExpand":
        return (
          <>
            <Button
              onClick={() => {
                setBarCodeModalVisible(true);
              }}
              className="dk-btn-expand-print-receipt dk-wd-auto dk-hgt-50 edit-text-btn"
              type="primary"
              size="large"
              icon={<PrinterFilled className="dk-btn-icon-align" />}
            >
              <IntlMessages id="components.barcodegenerator.printlabels" />
            </Button>
          </>
        );
      case "ProductDetail":
        return (
          <>
            <Button
              type="primary"
              className="dk-btn-print-receipt dk-wd-auto dk-hgt-50"
              icon={<PrinterFilled className="dk-btn-icon-align" />}
            >
              {" "}
              <IntlMessages id="components.barcodegenerator.printlabels" />
            </Button>
          </>
        );
      default:
        return (
          <Button
            type="primary"
            className="dk-btn-print-receipt dk-wd-auto dk-hgt-50"
            icon={<PrinterFilled className="dk-btn-icon-align" />}
          >
            {" "}
            <IntlMessages id="components.barcodegenerator.printlabels" />
          </Button>
        );
    }
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: "",
  });
  return (
    <>
      {barcodeProducts != undefined ? (
        <BarCodeModal isVisible={getBarCodeModalVisible} />
      ) : (
        ""
      )}
      <div style={{ display: "none" }}>
        <PrintBarcodes
          ref={componentRef}
          data={getSKUProducts}
          currData={currencyCode}
          labelPrintTypes={getCheckedLabelContent}
          labelType={getContentLabelType}
          today={moment().format("DD MM YYYY HH:MM:SS")}
        />
      </div>
      <ButtonLayouts type={buttonType} />
    </>
  );
};

export default BarCodeGenerator;
